import styled from 'styled-components';
import ArrowDownIcon from '../../../../../Icons/ArrowDownIcon';

export const HotelInfoLoader = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin: 0 auto;
    width: 79.3rem;
    background-color:${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.xxlarge};  
  `,
);

export const HeaderWithIconWrap = styled.div(
  props => `
  display:flex;
  align-items:center;
  justify-content: space-between;
  padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l30};
  border-bottom: 1px solid ${props.theme.colors.grey.lightdd};
`,
);

export const HotelInfoHeader = styled.div(
  props => `
    display:flex;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    width: 20rem;
    height:3rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
  
  `,
);

export const ArrowDownWrap = styled.div(
  props => `
  display:flex;
  justify-content:center;
  align-items:center;
  background: ${props.theme.colors.grey.lightf2};
  border-radius:50%;
  height:2.6rem;
  width:2.6rem;
`,
);

export const ArrowDown = styled(ArrowDownIcon)(
  props => `
  width:1rem;
  height:1rem;
  fill:${props.theme.colors.grey.grey50};
  `,
);

export const SpecialDealOuterWrap = styled.div(
  props => `
    display:flex;
  
  `,
);

export const SpecialDealWrap = styled.div(
  props => `
    display:flex;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    width:100%;
    height:4.2rem
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
  
  `,
);

export const HotelInfoOuterWrap = styled.div(
  props => `
    display:flex;
    padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l30} ${
    props.theme.spacing.large.l15
  };
  `,
);

export const ImageContainer = styled.div(
  props => `
    display:flex;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    width: 15rem;
    height: 15rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 ${props.theme.spacing.large.l20} 0 0 ;
  
  `,
);

export const HotelDetailsWrap = styled.div(
  props => `
    width: 57rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  
  `,
);

export const HotelNameLoader = styled.div(
  props => `
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    width:25.9rem;
    height:2.2rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 0 ${props.theme.spacing.small.s5} 0 ; 
  `,
);

export const HotelLocationLoader = styled.div(
  props => `
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    width:23.3rem;
    height:2.2rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 0 ${props.theme.spacing.small.s5} 0; 
  `,
);

export const HotelRatingLoader = styled.div(
  props => `
    display:flex;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    width:6.8rem;
    height:1.9rem
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
  `,
);

export const CheckinCheckoutWrap = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    margin: 0 ${props.theme.spacing.large.l30} 0 0; 
  `,
);

export const CheckingOuterWrap = styled.div(
  props => `
    display:flex;
    border: .1rem solid ${props.theme.colors.grey.lineGrey};
    border-radius: ${props.theme.misc.borderRadius.base};
    padding:${props.theme.spacing.base}; 
    margin: ${props.theme.spacing.base} ${props.theme.spacing.nospacing};
  `,
);

export const CheckInTitle = styled.div(
  props => `
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    width:6.8rem;
    height:1.9rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 0 ${props.theme.spacing.small.s2} 0; 
  `,
);

export const CheckInDay = styled.div(
  props => `
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    width:9.8rem;
    height:1.9rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 0 ${props.theme.spacing.small.s2}  0; 
  `,
);

export const CheckInTime = styled.div(
  props => `
    display:flex;
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    width:6.8rem;
    height:1.9rem
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
  `,
);

export const RoomTitleOuterWrap = styled.div(
  props => `
    display:flex;
    flex-direction: column;
    border-top: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
    margin: 0 0 ${props.theme.spacing.base} 0;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l30} ${props.theme.spacing.base};
  `,
);

export const RoomTitleWrap = styled.div(
  props => `
    width:20rem;
    height:2.5rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 0 ${props.theme.spacing.base} 0;
  `,
);

export const RoomInclusionsWrap = styled.div(
  props => `
    width: 40rem;
    height: 1.5rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 0 ${props.theme.spacing.base} 0;

  `,
);

export const RoomDetailsContainer = styled.div(
  props => `
    display: flex;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l35};
  `,
);

export const RoomImage = styled.div(
  props => `
    width:13.9rem;
    height:9.5rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 ${props.theme.spacing.large.l35} 0 0;

  `,
);

export const RoomDetailsWrap = styled.div(
  props => `
    // width:20rem;
    // height:2.5rem
    // border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
  `,
);

export const PriceIncludes = styled.div(
  props => `
    width:8.8rem;
    height:1.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 0 ${props.theme.spacing.base} 0;
  `,
);

export const FreeAmenities = styled.div(
  props => `
    width:17rem;
    height:1.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 0 ${props.theme.spacing.base} 0;
  `,
);

export const CancellationPolicy = styled.div(
  props => `
    width:17rem;
    height:2.2rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
    margin: 0 0 ${props.theme.spacing.base} 0;
  `,
);

export const ViewBooking = styled.div(
  props => `
    width:11.8rem;
    height:1.6rem;
    border-radius: ${props.theme.misc.borderRadius.small};
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
  `,
);
